<template>
  <div>
    <ticket v-for="ticket in tickets" :key="ticket.id"
      :event-name="event.title"
      :event-image="event.image"
      :event-location="event.location"
      :event-date="event.date"
      :event-note="event.note"
      :event-show-qrcode="event.show_qrcode"
      :ticket-type-name="ticket.name"
      :ticket-type-value="ticket.value"
      :ticket-number="ticket.number"
      :ticket-code="ticket.code">
    </ticket>
  </div>
</template>

<script>
import Ticket from './../Ticket'

export default {
  name: 'DealerRenderTickets',
  components: {
    'ticket': Ticket
  },
  data () {
    return {
      event: null,
      tickets: []
    }
  },
  methods: {
    print () {
      let dealer = this.$route.params.dealer
      let batch = this.$route.params.batch
      let quantity = this.$route.params.quantity

      let url = process.env.VUE_APP_URL_APP + '/b/dealers/' + dealer +
        '/batches/' + batch +
        '/bulk/' + quantity +
        '/tickets'

      this.$http.post(url, {}).then(res => {
        this.event = res.body.event
        this.tickets = res.body.tickets
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    },
    reprint () {
      let dealer = this.$route.params.dealer
      let numbers = this.$route.params.numbers

      let url = process.env.VUE_APP_URL_APP + '/b/dealers/' + dealer +
        '/tickets?numbers=' + numbers

      return this.$http.get(url).then(res => {
        this.event = res.body.event
        this.tickets = res.body.tickets
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    }
  },
  mounted () {
    let print = !this.$route.params.numbers

    if (print) {
      this.print()
    } else {
      this.reprint()
    }
  },
  updated () {
    let t = setInterval(() => {
      if (document.readyState === 'complete') {
        setTimeout(function () {
          window.print()
        }, 100)
        setTimeout(function () {
          window.close()
        }, 150)
        clearInterval(t)
      }
    }, 500)
  }
}
</script>
